import SimpleComponentRegistery from "../qlib/SimpleComponentRegistery";
import Component from "../qlib/Component";
import Chain from "../qlib/Chain";
import anime from "animejs";

export default class FavoriteComponent extends Component
{
    constructor(element)
    {
        super(element);

        this.icon = element.querySelector(".fa-heart");

        this.object_id = this.element.dataset.objectId;
        this.active = this.element.dataset.active || false;
        this.remove = this.element.dataset.remove;

        this.element.addEventListener("click", event => {

            let messageData = {
                object_id: this.object_id,
                active: !this.active
            };
            this.requestChange(messageData);
            this.sendMessage("favorite", "update", messageData);

            if (this.active)
            {
                this.sendMessage("header", "show");
                setTimeout(() => this.animate(), 250);
            }
        });
    }

    animate()
    {
        if (!this.icon) {
            return;
        }

        let header = document.querySelector(".js-user");
        let footerMobile = document.querySelector(".js-user-mobile");
        let footerMobileParent = document.querySelector(".js-user-mobile-parent");

        if (window.getComputedStyle(footerMobileParent).position === 'fixed') {
            header = footerMobile;
        }

        let icon_bbox = this.icon.getBoundingClientRect();
        let header_bbox = header.getBoundingClientRect();

        let clone = this.icon.cloneNode(true);
        clone.className = "fa-heart fas heart-animated";
        clone.style.left = icon_bbox.left + "px";
        clone.style.top = icon_bbox.top + "px";

        document.body.appendChild(clone);

        let timeline = anime.timeline({
            easing: 'linear'
        });

        timeline.add({
            targets: clone,
            duration: 350,
            translateX: header_bbox.left - icon_bbox.left + header_bbox.width / 2.5,
            translateY: header_bbox.top - icon_bbox.top + header_bbox.height / 4
        });

        timeline.add({
            targets: header,
            opacity: 0,
            duration: 250
        });

        timeline.add({
            targets: header,
            opacity: 1,
            duration: 250
        });

        timeline.add({
            targets: clone,
            opacity: 0,
            duration: 250
        });

        timeline.finished.then(() => {
            clone.parentNode.removeChild(clone);
            this.sendMessage("header", "hide");
        });
    }

    updateIcon(data)
    {
        if (this.object_id !== data.object_id)
        {
            return;
        }

        if (this.active !== data.active)
        {
            if (data.active)
            {
                if (this.icon) {
                    Chain(this.icon.classList).add("fas").remove("fal");
                }
            }
            else
            {
                if (this.icon) {
                    Chain(this.icon.classList).add("fal").remove("fas");
                }

                if (this.remove) {
                  document.querySelector(this.remove).remove();
                }
            }

            this.active = data.active;
        }

    }

    requestChange(data)
    {
        if (this.object_id !== data.object_id)
        {
            return false;
        }

        let requestSucces = false;

        if (this.active !== data.active)
        {
            if (data.active)
            {
                fetch('/mijnambivast/favorieten/addfavorite?pand_id='+data.object_id)
                    .then(res => {
                        if (res.status === 200) {
                            requestSucces = true;
                        }
                        if (res.status === 403 || res.url.includes('login')) {
                            window.location.replace("/mijnambivast/login?referer="+encodeURI(window.location.pathname)+"&favorite_pand_id="+data.object_id);
                        }
                    });
            }
            else
            {
                fetch('/mijnambivast/favorieten/removefavorite?pand_id='+data.object_id)
                    .then(res => {
                        if (res.status === 200) {
                            requestSucces = true;
                        }
                        if (res.status === 403 || res.url.includes('login')) {
                            window.location.replace("/mijnambivast/login?referer="+encodeURI(window.location.pathname)+"&favorite_pand_id="+data.object_id);
                        }
                    });
            }
        }

        return requestSucces;
    }

    onMessage(name, data)
    {
        switch(name)
        {
            case "update":
                this.updateIcon(data);
                break;
        }
    }
}

SimpleComponentRegistery.register("favorite", FavoriteComponent);